var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarnIcon = function SvgWarnIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6335 11.6667L10.2335 2.33332C9.70017 1.39999 8.4335 1.06666 7.50017 1.59999C7.16684 1.79999 6.90017 2.06666 6.76684 2.33332L1.36684 11.6667C0.833504 12.6 1.16684 13.8667 2.10017 14.4C2.4335 14.6 2.76684 14.6667 3.10017 14.6667H13.8335C14.9668 14.6667 15.8335 13.7333 15.8335 12.6667C15.9002 12.2667 15.7668 11.9333 15.6335 11.6667ZM8.50017 12C8.10017 12 7.8335 11.7333 7.8335 11.3333C7.8335 10.9333 8.10017 10.6667 8.50017 10.6667C8.90017 10.6667 9.16684 10.9333 9.16684 11.3333C9.16684 11.7333 8.90017 12 8.50017 12ZM9.16684 8.66666C9.16684 9.06666 8.90017 9.33332 8.50017 9.33332C8.10017 9.33332 7.8335 9.06666 7.8335 8.66666V5.99999C7.8335 5.59999 8.10017 5.33332 8.50017 5.33332C8.90017 5.33332 9.16684 5.59999 9.16684 5.99999V8.66666Z",
    fill: "#5656FC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarnIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warnIcon.f6522611.svg";
export { ForwardRef as ReactComponent };